/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbShowMoreTextContainer } from "abreact/layout/AbShowMoreTextContainer";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
/**
 * A React component that can safely render HTML from an unknown source.
 *
 * Note: the string is sanitized before rendering to remove scripts and other
 * potentially dangerous HTML constructs.
 */
export class AbHtmlContent extends React.Component {
  render() {
    const {
      html,
      tooltip,
      children
    } = this.props;
    let content = /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-html-content", this.props), html && /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: StringUtils.sanitizeHtmlString(html)
      }
    }), children);
    if (tooltip != null && tooltip !== "") {
      content = /*#__PURE__*/React.createElement(AbWithTooltip, {
        tooltip: tooltip
      }, content);
    }
    return this.props.truncateLongContent ? /*#__PURE__*/React.createElement(AbShowMoreTextContainer, {
      onResize: this.props.onResize
    }, content) : content;
  }
}
//# sourceMappingURL=AbHtmlContent.js.map
